var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DocumentHeader',{attrs:{"header":"หน้าใบส่งคืนสินค้า (รอการอัพเดท)","link_back":"stock/document/returnproductreceipt"}}),_c('Document_details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }